/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import styled from "@emotion/styled";
import { Body1, colors, Title1 } from "@utils/ui_palette";
import { rgba } from "emotion-rgba";

interface IModule {
  id: number;
  question: string;
  anwser: string;
  choice: string[] | null;
  question_image: null | string;
  score: number;
  answer_submit: string;
  answer_s3: string;
  answer_id: string;
}

interface IModal {
  item: IModule | null;
  type: string | null;
  callback: (item: IModule, type: string, answer: string | number) => void;
  handleModal: (state: boolean) => void;
}

function InterviewModal({ item, type, callback, handleModal }: IModal) {
  const [currentPoint, setPoint] = useState<number | null>(null);
  const points = [0, 1, 2, 3, 4, 5];
  const points2 = [6, 7, 8, 9, 10];

  const handlePoint = useCallback(
    (value: number) => {
      setPoint(value);
    },
    [setPoint]
  );

  const closeModal = useCallback(() => {
    handleModal(false);
  }, []);

  const handleSubmit = useCallback(() => {
    if (item && type) {
      closeModal();

      if (currentPoint && type === "Make_the_sentence") {
        callback(item, type, currentPoint);
        return;
      }
      callback(item, type, item.anwser);
    }
  }, [currentPoint]);

  return (
    <Modals>
      <ModalBody>
        {item && type && (
          <>
            <Title1>{type}</Title1>
            <Contents>
              <Question>{item.question}</Question>

              <ContentsBox>
                {item.answer_s3 !== "" && (
                  <>
                    <Audio target="_blank" href={item.answer_s3}>
                      Download
                    </Audio>
                    <Body1 marginTop={10} color={colors.Gray70}>
                      Please download and listen to it. A preview function
                      willbe developed later.
                    </Body1>
                  </>
                )}
              </ContentsBox>

              <ScoreBox>
                {points.map((point) => (
                  <Score
                    key={point}
                    active={currentPoint === point}
                    onClick={() => handlePoint(point)}
                  >
                    {point} point
                  </Score>
                ))}
              </ScoreBox>
              {type === "Create_a_story" && (
                <ScoreBox>
                  {points2.map((point) => (
                    <Score
                      key={point}
                      active={currentPoint === point}
                      onClick={() => handlePoint(point)}
                    >
                      {point} point
                    </Score>
                  ))}
                </ScoreBox>
              )}
            </Contents>
          </>
        )}
        {item && type && (
          <ButtonGroup>
            <ConfirmButton
              onClick={handleSubmit}
              active={currentPoint ? false : true}
              disabled={currentPoint ? false : true}
            >
              Submit
            </ConfirmButton>

            <CancelButton onClick={closeModal}>Cancel</CancelButton>
          </ButtonGroup>
        )}
      </ModalBody>
    </Modals>
  );
}

const Modals = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: ${rgba(colors.Black, 0.5)};
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  width: 900px;
  padding: 30px;
  background-color: ${colors.White};
  border-radius: 15px;
`;

const Contents = styled.div``;

const Audio = styled.a`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background-color: ${colors.Primary50};
  color: ${colors.White};
  font-weight: bold;
  border: 0;
  border-radius: 10px;
  outline: 0;
`;

const ContentsBox = styled.div``;

const Question = styled.div`
  padding: 20px;
  font-size: 36px;
  border: 1px solid ${colors.Black};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px auto;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
`;

const ConfirmButton = styled.button<{ active: boolean }>`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 0;
  background-color: ${(props) =>
    props.active ? colors.Gray30 : colors.Primary50};
  border-radius: 8px;
  color: ${colors.White};
  cursor: ${(props) => (props.active ? "not-allowed" : "pointer")};
`;

const CancelButton = styled.button`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 1px solid ${colors.Black};
  background-color: ${colors.White};
  border-radius: 8px;
  color: ${colors.Black};
  cursor: pointer;
`;

const ScoreBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
`;

const Score = styled.div<{ active: boolean }>`
  flex: 1;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.active ? colors.Primary50 : colors.White};
  color: ${(props) => (props.active ? colors.White : colors.Gray50)};
  border: 1px solid ${(props) => (props.active ? colors.White : colors.Gray50)};
  font-size: 18px;
  height: 50px;
  border-radius: 10px;
  cursor: pointer;
`;

export default InterviewModal;
